module.exports = __webpack_public_path__ + "static/assets/3e497f15fec4949163976f57318166e0.svg";